// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","cardContent":"Card_cardContent__WdsqS","btn":"Card_btn__GDQIk","title":"Card_title__A6GVy","text":"Card_text__a7tLC"};